import { FC } from 'react'

import { usePermissions } from '@/api/models/auth/hooks/usePermissions'
import { ProjectSource } from '@/api/models/auth/lib/auth.types'
import { useSelectedProject } from '@/api/models/main/hooks/useSelectedProject'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { FeedSummary } from '@/components/entities/feed'
import { RequestsSummary } from '@/components/entities/requests'

import { CardsSummary } from './CardsSummary'
import { StoriesSummary } from './stories/StoriesSummary'

const IndexRootPage: FC = () => {
  const { breakpoint } = useCurrentBreakpoint()

  const isLargeScreen = [ScreenSize.Xxl].includes(breakpoint)
  const permissions = usePermissions()

  const { selectedProject } = useSelectedProject()

  const isProjectBU = selectedProject?.src === ProjectSource.BU
  const isProjectSC = selectedProject?.src === ProjectSource.SC

  return (
    <div className="flex gap-32 xl:flex-col">
      <div className="flex w-full flex-col">
        {!isLargeScreen && <StoriesSummary />}
        <div>
          {(isProjectSC || isProjectBU) && (
            <CardsSummary projectSource={selectedProject.src} />
          )}
        </div>
        <div className="xl:mr-30 lg:mr-24 xs:mr-16">
          <RequestsSummary isAccessForbidden={!permissions.requests} />
        </div>
      </div>
      <div className="mr-30 flex h-full min-h-[150px] max-w-[496px] flex-col xl:max-w-full lg:mr-24 xs:mr-16">
        {isLargeScreen && <StoriesSummary />}
        <FeedSummary isAccessForbidden={!permissions.posts} />
      </div>
    </div>
  )
}

export default IndexRootPage
